import { IColumn } from 'core-components/library/list/types'

export const columns: IColumn[] = [
  {
    field: 'PartnerId',
    title: 'PartnerId',
    priority: 1,
  },
  {
    field: 'PartnerName',
    title: 'PartnerName',
    priority: 2,
  },
  {
    field: 'ContactID',
    title: 'Contact ID',
    priority: 3,
  },
  {
    field: 'FirstName',
    title: 'First Name',
    priority: 4,
  },
  {
    field: 'LastName',
    title: 'Last Name',
    priority: 5,
  },
  {
    field: 'Email',
    title: 'Email',
    priority: 6,
  },
  {
    field: 'PR_HP_ROLE',
    title: 'Hp Roles',
    priority: 7,
  },
]
